import React from "react";
import { makeStyles } from "@mui/styles";
import "react-multi-carousel/lib/styles.css";
import { Box, useTheme, IconButton, Stack } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

export interface CarousalVisualProps {
  images: { label: string; src: string }[];
}

const useStyles = makeStyles((theme: any) => ({
  leftArrow: {
    width: "54px !important",
    height: "54px !important",
    borderRadius: "32px !important",
    backgroundColor: `${theme.palette.common.white} !important`,
    boxShadow: "5px 5px 20px rgba(0, 0, 0, 0.25) !important",
    position: "absolute",
    left: "-22px"
  },
  rightArrow: {
    width: "54px !important",
    height: "54px !important",
    borderRadius: "32px !important",
    backgroundColor: `${theme.palette.common.white} !important`,
    boxShadow: "5px 5px 50px rgba(0, 0, 0, 0.25) !important",
    position: "absolute",
    right: "-22px"
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 255,
    width: "100%",
    overflow: "hidden"
  }
}));

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const CarousalVisual = ({ images }: CarousalVisualProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };
  return (
    <Box sx={{ flexGrow: 1 }} width="100%">
      <AutoPlaySwipeableViews
        disabled
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        interval={50000}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {images.map((step, index) =>
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2
              ? <Stack direction="row" position="relative" alignItems="center">
                  <IconButton
                    className={classes.rightArrow}
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    <i className="far fa-arrow-left font-primary" />
                  </IconButton>
                  <Box
                    className={classes.imageContainer}
                    sx={{
                      background: `url(${step.src}) `,
                      backgroundPosition: "center",
                      backgroundSize: "cover"
                    }}
                  />
                  <IconButton
                    className={classes.leftArrow}
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    <i className="far fa-arrow-right font-primary" />
                  </IconButton>
                </Stack>
              : null}
          </div>
        )}
      </AutoPlaySwipeableViews>
    </Box>
  );
};
export default CarousalVisual;
